module.exports = __webpack_public_path__ + "static/media/logo.9d3e324e.png";